import ReportsService from '@/services/ReportsService';
import ReportsIndexedDBRepo from '@/repos/impl/ReportsIndexedDBRepo';

export default class Service {

    public static readonly reports = new ReportsService(new ReportsIndexedDBRepo());

}
